import { render, staticRenderFns } from "./orgResendCredential.vue?vue&type=template&id=652c512c&"
import script from "./orgResendCredential.vue?vue&type=script&lang=js&"
export * from "./orgResendCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports